// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * An individual LN2 signal definition in the message catalog.
 */
export class Message implements flatbuffers.IUnpackableObject<MessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Message {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  messageTypeId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  shortMessage(): string | null;
  shortMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  shortMessage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  enumId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Ln2.EncodedMessageContent discriminant (OneHot=0, BitMask=1).
   */
  messageContentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  deviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  position(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Elevator-specific status message sub-type enum value.
   */
  elevatorStatusMessageType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Escalator-specific status message sub-type enum value.
   */
  escalatorStatusMessageType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * JSON-encoded `ControllerInfo` message data.
   */
  controllerInfoMsgDataJson(): string | null;
  controllerInfoMsgDataJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  controllerInfoMsgDataJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Binary `FlatBuffer`-encoded `ControllerInfo` data.
   */
  ciDataBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  ciDataBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  ciDataBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMessage(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMessageTypeId(builder: flatbuffers.Builder, messageTypeId: number) {
    builder.addFieldInt32(1, messageTypeId, 0);
  }

  static addShortMessage(builder: flatbuffers.Builder, shortMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, shortMessageOffset, 0);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, descriptionOffset, 0);
  }

  static addEnumId(builder: flatbuffers.Builder, enumId: number) {
    builder.addFieldInt32(4, enumId, 0);
  }

  static addMessageContentType(builder: flatbuffers.Builder, messageContentType: number) {
    builder.addFieldInt32(5, messageContentType, 0);
  }

  static addDeviceType(builder: flatbuffers.Builder, deviceType: LiftType) {
    builder.addFieldInt8(6, deviceType, LiftType.ELEVATOR);
  }

  static addPosition(builder: flatbuffers.Builder, position: boolean) {
    builder.addFieldInt8(7, +position, +false);
  }

  static addElevatorStatusMessageType(
    builder: flatbuffers.Builder,
    elevatorStatusMessageType: number,
  ) {
    builder.addFieldInt32(8, elevatorStatusMessageType, 0);
  }

  static addEscalatorStatusMessageType(
    builder: flatbuffers.Builder,
    escalatorStatusMessageType: number,
  ) {
    builder.addFieldInt32(9, escalatorStatusMessageType, 0);
  }

  static addControllerInfoMsgDataJson(
    builder: flatbuffers.Builder,
    controllerInfoMsgDataJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, controllerInfoMsgDataJsonOffset, 0);
  }

  static addCiDataBinary(builder: flatbuffers.Builder, ciDataBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, ciDataBinaryOffset, 0);
  }

  static createCiDataBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCiDataBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, deletedAtOffset, 0);
  }

  static endMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMessage(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    messageTypeId: number,
    shortMessageOffset: flatbuffers.Offset,
    descriptionOffset: flatbuffers.Offset,
    enumId: number,
    messageContentType: number,
    deviceType: LiftType,
    position: boolean,
    elevatorStatusMessageType: number,
    escalatorStatusMessageType: number,
    controllerInfoMsgDataJsonOffset: flatbuffers.Offset,
    ciDataBinaryOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Message.startMessage(builder);
    Message.addId(builder, idOffset);
    Message.addMessageTypeId(builder, messageTypeId);
    Message.addShortMessage(builder, shortMessageOffset);
    Message.addDescription(builder, descriptionOffset);
    Message.addEnumId(builder, enumId);
    Message.addMessageContentType(builder, messageContentType);
    Message.addDeviceType(builder, deviceType);
    Message.addPosition(builder, position);
    Message.addElevatorStatusMessageType(builder, elevatorStatusMessageType);
    Message.addEscalatorStatusMessageType(builder, escalatorStatusMessageType);
    Message.addControllerInfoMsgDataJson(builder, controllerInfoMsgDataJsonOffset);
    Message.addCiDataBinary(builder, ciDataBinaryOffset);
    Message.addCreatedAt(builder, createdAtOffset);
    Message.addUpdatedAt(builder, updatedAtOffset);
    Message.addDeletedAt(builder, deletedAtOffset);
    return Message.endMessage(builder);
  }

  unpack(): MessageT {
    return new MessageT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.messageTypeId(),
      this.shortMessage(),
      this.description(),
      this.enumId(),
      this.messageContentType(),
      this.deviceType(),
      this.position(),
      this.elevatorStatusMessageType(),
      this.escalatorStatusMessageType(),
      this.controllerInfoMsgDataJson(),
      this.bb!.createScalarList<number>(this.ciDataBinary.bind(this), this.ciDataBinaryLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: MessageT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.messageTypeId = this.messageTypeId();
    _o.shortMessage = this.shortMessage();
    _o.description = this.description();
    _o.enumId = this.enumId();
    _o.messageContentType = this.messageContentType();
    _o.deviceType = this.deviceType();
    _o.position = this.position();
    _o.elevatorStatusMessageType = this.elevatorStatusMessageType();
    _o.escalatorStatusMessageType = this.escalatorStatusMessageType();
    _o.controllerInfoMsgDataJson = this.controllerInfoMsgDataJson();
    _o.ciDataBinary = this.bb!.createScalarList<number>(
      this.ciDataBinary.bind(this),
      this.ciDataBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): MessageT {
    const t = new MessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("message_type_id")) {
      t.messageTypeId = this.messageTypeId();
    }
    if (fieldSet.has("short_message")) {
      t.shortMessage = this.shortMessage();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("enum_id")) {
      t.enumId = this.enumId();
    }
    if (fieldSet.has("message_content_type")) {
      t.messageContentType = this.messageContentType();
    }
    if (fieldSet.has("device_type")) {
      t.deviceType = this.deviceType();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("elevator_status_message_type")) {
      t.elevatorStatusMessageType = this.elevatorStatusMessageType();
    }
    if (fieldSet.has("escalator_status_message_type")) {
      t.escalatorStatusMessageType = this.escalatorStatusMessageType();
    }
    if (fieldSet.has("controller_info_msg_data_json")) {
      t.controllerInfoMsgDataJson = this.controllerInfoMsgDataJson();
    }
    if (fieldSet.has("ci_data_binary")) {
      t.ciDataBinary = this.bb!.createScalarList<number>(
        this.ciDataBinary.bind(this),
        this.ciDataBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class MessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public messageTypeId: number = 0,
    public shortMessage: string | Uint8Array | null = null,
    public description: string | Uint8Array | null = null,
    public enumId: number = 0,
    public messageContentType: number = 0,
    public deviceType: LiftType = LiftType.ELEVATOR,
    public position: boolean = false,
    public elevatorStatusMessageType: number = 0,
    public escalatorStatusMessageType: number = 0,
    public controllerInfoMsgDataJson: string | Uint8Array | null = null,
    public ciDataBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const shortMessage = this.shortMessage !== null ? builder.createString(this.shortMessage!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;
    const controllerInfoMsgDataJson =
      this.controllerInfoMsgDataJson !== null
        ? builder.createString(this.controllerInfoMsgDataJson!)
        : 0;
    const ciDataBinary = Message.createCiDataBinaryVector(builder, this.ciDataBinary);
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return Message.createMessage(
      builder,
      id,
      this.messageTypeId,
      shortMessage,
      description,
      this.enumId,
      this.messageContentType,
      this.deviceType,
      this.position,
      this.elevatorStatusMessageType,
      this.escalatorStatusMessageType,
      controllerInfoMsgDataJson,
      ciDataBinary,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): MessageT {
    const obj = new MessageT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.messageTypeId = this.messageTypeId;
    obj.shortMessage = this.shortMessage;
    obj.description = this.description;
    obj.enumId = this.enumId;
    obj.messageContentType = this.messageContentType;
    obj.deviceType = this.deviceType;
    obj.position = this.position;
    obj.elevatorStatusMessageType = this.elevatorStatusMessageType;
    obj.escalatorStatusMessageType = this.escalatorStatusMessageType;
    obj.controllerInfoMsgDataJson = this.controllerInfoMsgDataJson;
    obj.ciDataBinary = [...this.ciDataBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: MessageT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.messageTypeId !== other.messageTypeId) return false;
    if (this.shortMessage !== other.shortMessage) return false;
    if (this.description !== other.description) return false;
    if (this.enumId !== other.enumId) return false;
    if (this.messageContentType !== other.messageContentType) return false;
    if (this.deviceType !== other.deviceType) return false;
    if (this.position !== other.position) return false;
    if (this.elevatorStatusMessageType !== other.elevatorStatusMessageType) return false;
    if (this.escalatorStatusMessageType !== other.escalatorStatusMessageType) return false;
    if (this.controllerInfoMsgDataJson !== other.controllerInfoMsgDataJson) return false;
    if (this.ciDataBinary.length !== other.ciDataBinary.length) return false;
    for (let i = 0; i < this.ciDataBinary.length; i++) {
      if (this.ciDataBinary[i] !== other.ciDataBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 6, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
